import React from 'react';
import type { ReactNode } from 'react';
import type { CSSObject } from '@balance-web/core';

import { ThemeProvider } from './ThemeProvider';
import { PackageProviders } from './PackageProviders';
import type { ThemeProviderProps } from './ThemeProvider';

type ReckonBalanceCoreProps = {
  themeMode: 'light';
  children?: ReactNode;
  globalStyles?: CSSObject;
} & Pick<
  ThemeProviderProps,
  'linkComponent' | 'themeOverrides' | 'fastMode' | 'portalParent'
>;

export const ReckonBalanceCore = ({
  themeOverrides,
  linkComponent,
  globalStyles,
  fastMode,
  portalParent,
  children,
}: ReckonBalanceCoreProps) => {
  return (
    <ThemeProvider
      fastMode={fastMode}
      globalStyles={globalStyles}
      linkComponent={linkComponent}
      portalParent={portalParent}
      themeOverrides={themeOverrides}
    >
      <PackageProviders>{children}</PackageProviders>
    </ThemeProvider>
  );
};
